<template>
  <div class="send-container">
    <div class="header">
      <img src="@/assets/logo.png" alt="Logos" class="logo" />
    </div>

    <div class="form-fields">
      <div class="input-group">
        <!-- <img src="@/assets/icon-mail.svg" class="icon" /> -->
        <input type="email" v-model="correo" placeholder="Escribir correo" />
      </div>
      <div class="input-group">
        <!-- <img src="@/assets/icon-whatsapp.svg" class="icon" /> -->
        <input type="tel" v-model="telefono" placeholder="Escribir teléfono" />
      </div>
    </div>

    <div class="bottom-actions">
      <div class="label">Escoge como<br />recibir tu foto</div>
      <div class="download" v-if="imagenLista" @click="descargar">
        Descargar
      </div>

      <div class="finalize" @click="guardarDatos">Finalizar</div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      correo: '',
      telefono: '',
      imagenProcesada: null,
      imagenLista: false,
      chequeoIntervalo: null,
      clavePendiente: null,
    };
  },
  created() {
    this.clavePendiente = this.$store.state.tokens.clavePendiente;
    this.iniciarChequeoImagen();
  },
  beforeUnmount() {
    if (this.chequeoIntervalo) {
      clearInterval(this.chequeoIntervalo);
    }
  },
  methods: {
    iniciarChequeoImagen() {
      if (!this.clavePendiente) return;

      this.chequeoIntervalo = setInterval(async () => {
        try {
          const response = await axios.post("/api/consultar-imagen", {
            clave_pendiente: this.clavePendiente,
          });

          if (response.data && response.data.imagen_url) {
            this.imagenProcesada = response.data.imagen_url;
            localStorage.setItem("processedImageName", this.imagenProcesada);
            this.imagenLista = true;

            clearInterval(this.chequeoIntervalo); // ⛔ detener el chequeo
          }
        } catch (error) {
          console.error("Error al consultar la imagen procesada:", error);
        }
      }, 4000);
    },
    async guardarDatos() {
      const campos = [];
      if (this.correo) campos.push(this.correo);
      if (this.telefono) campos.push(this.telefono);

      const premio = campos.join(', ');

      try {
        const payload = {
          clave_pendiente: this.$store.state.tokens.clavePendiente,
          token_final: this.$store.state.tokens.tokenFinal,
          premio,
        };

        await axios.post('/api/registros/asignar-premio', payload);
        this.$router.push('/ver-qr');
      } catch (error) {
        console.error('Error al guardar los datos:', error);
        alert('No se pudo guardar la información');
      }
    },
    descargar() {
      const nombreImagen = localStorage.getItem("processedImageName");
      if (!nombreImagen) return;

      const imageUrl = `https://activacioneshp.test/img/imagenes_modificadas/${nombreImagen}`;

      // Abrir en una nueva ventana "limpia" tipo popup
      window.open(
        imageUrl,
        '_blank',
        'toolbar=no,location=no,status=no,menubar=no,scrollbars=no,resizable=yes,width=800,height=600'
      );
    }

  }
};
</script>


<style scoped>
.send-container {
  background-color: #0095d9;
  width: 100vw;
  height: 100vh;
  font-family: 'FormaDJRDisplay', sans-serif;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  color: white;
  overflow: hidden;
  padding: 0 5vw;
}

.header {
  position: absolute;
  top: 2vh;
  left: 2vw;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.header .logo {
  width: 180px;
  max-width: 45vw;
}

.tech-partner {
  font-size: 0.9rem;
  margin-top: 0.5rem;
  text-align: center;
}

.form-fields {
  display: flex;
  flex-direction: column;
  gap: 2vh;
  margin-bottom: 5vh;
  width: 100%;
  max-width: 500px;
}

.input-group {
  display: flex;
  align-items: center;
  background: white;
  border-radius: 4px;
  padding: 1vh 1vw;
}

.input-group .icon {
  width: 24px;
  margin-right: 1vw;
}

.input-group input {
  border: none;
  flex: 1;
  font-size: 1.2rem;
  outline: none;
  color: #000;
}

.bottom-actions {
  position: absolute;
  bottom: 4vh;
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 0 5vw;
  align-items: center;
}

.label {
  font-size: 1.2rem;
  line-height: 1.3;
  text-align: left;
}

.download {
  text-align: center;
  font-size: 1.2rem;
  cursor: pointer;
  border-top: 1px solid white;
  border-bottom: 1px solid white;
  padding: 0.5rem 2rem;
}

.finalize {
  font-size: 1.2rem;
  cursor: pointer;
}
</style>
